module.exports = __webpack_public_path__ + "static/media/icon-10.f342ed5a.png";